import React, { Component,Fragment } from "react";
import logo from "./logo.svg";

import { BrowserRouter as Router, Route, Switch,Link } from 'react-router-dom';

import Header from './componentes/Header';
import Encuesta from './componentes/Encuesta';
import Cookies from 'universal-cookie';


class App extends Component {

  constructor(props) {
    // Required step: always call the parent class' constructor
    super(props);
    this.cookies = new Cookies();
  }


  render() {
    return (
      <Fragment>
            <Header />
            <Encuesta/>
      </Fragment>
    );
  }
}

export default App;
